import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

import { useGetHmgs } from "../../../hooks/hmg.hooks";

const { Option } = Select;

const HMGSelect = (props) => {
  const { value, onChange, autoDisable, setHmgListRef, ...otherProps } = props;
  const { data: hmgList, isLoading } = useGetHmgs();

  useEffect(() => {
    if (setHmgListRef !== undefined) {
      setHmgListRef(hmgList ?? []);
    }
  }, [hmgList]);

  return (
    <Select
      placeholder="Hotel Management Group"
      showSearch
      loading={isLoading}
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      value={value}
      onChange={onChange}
      disabled={autoDisable ? isLoading : false}
      {...otherProps}
    >
      {Array.isArray(hmgList)
        ? hmgList.map((hmg) => (
            <Option value={hmg._id} key={hmg._id}>
              {hmg.hmg_name}
            </Option>
          ))
        : null}
    </Select>
  );
};

HMGSelect.defaultProps = {
  value: undefined,
  autoDisable: false,
  setHmgListRef: undefined,
};

HMGSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoDisable: PropTypes.bool,
  setHmgListRef: PropTypes.func,
};

export default HMGSelect;
